var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M24.266 12.276c0-.816-.066-1.636-.207-2.438H12.74v4.62h6.482a5.56 5.56 0 0 1-2.399 3.647v2.999h3.867c2.271-2.09 3.576-5.177 3.576-8.828"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M12.74 24.001c3.237 0 5.966-1.062 7.955-2.897l-3.867-2.998c-1.076.732-2.465 1.146-4.083 1.146-3.131 0-5.786-2.112-6.738-4.951h-3.99v3.09a12 12 0 0 0 10.723 6.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M6.003 14.3a7.2 7.2 0 0 1 0-4.594v-3.09H2.017a12.01 12.01 0 0 0 0 10.776z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M12.74 4.75a6.52 6.52 0 0 1 4.603 1.799l3.427-3.426A11.53 11.53 0 0 0 12.74 0 12 12 0 0 0 2.017 6.615l3.986 3.09C6.95 6.863 9.609 4.75 12.74 4.75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h24v24H.5z"
  })))));
};
export default SvgGoogle;